import styled from 'styled-components';

const Wrapper = styled.div`
  transition: all ease 0.25s;
  /* transition: ${({ animationState }) => (animationState === 'entered' ? 'none' : 'all ease 0.25s')}; */
  opacity: ${({ animationState }) => (animationState === 'entering' || animationState === 'entered' ? 1 : 0)};
  transform: scale(${({ animationState }) => (animationState === 'entering' || animationState === 'entered' ? 1 : 0)});
  /* display: ${({ animationState }) => (animationState === 'exited' ? 'none' : 'block')}; */
  @media only screen and (min-width: 1015px) {
    width: ${({ fullScreen }) => fullScreen ? '100%' : '1015px'};
    height: ${({ fullScreen }) => fullScreen ? '100%' : '535px'};
    /* width: 1015px; */
  }
  width: 100%;
  height: 100%;
  min-height: 535px;
  background-color: #fff;
  color: #393939;
  border-radius: 5px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
  user-select: none;
  z-index: 100;
  position: absolute;
`;

export default Wrapper;
